import React, { useState, useEffect } from 'react';
import './styles/ComposerImage.css';

/**
 * The picked photo, shown before the post is sent.
 *
 * Until now the composer only said "1 photo", so there was no way to tell a
 * mis-tap from the right picture until after posting. The preview is built
 * from an object URL rather than a FileReader: nothing is decoded into memory,
 * and the URL is released as soon as the file changes or the composer closes.
 */

const formatSize = (bytes) => {
  const n = Number(bytes || 0);
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};

export default function ComposerImage({ file, onClear }) {
  const [url, setUrl] = useState('');

  useEffect(() => {
    if (!file) {
      setUrl('');
      return undefined;
    }
    const objectUrl = URL.createObjectURL(file);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  if (!file || !url) return null;

  return (
    <div className="composer-image">
      <img src={url} alt={file.name || 'Selected photo'} className="composer-image-thumb" />

      <div className="composer-image-meta">
        <span className="composer-image-name" title={file.name}>{file.name}</span>
        <span className="composer-image-size">{formatSize(file.size)}</span>
      </div>

      <button
        type="button"
        className="composer-image-remove"
        onClick={onClear}
        aria-label="Remove this photo"
      >
        ×
      </button>
    </div>
  );
}
